import styled, { createGlobalStyle, css } from 'styled-components'

import printStyles from './print.css'

export const HsAppGlobalStyle = createGlobalStyle`
  body, html {
      min-height: 100vh;
      margin:0;
      ${({ isFullscreen }) => {
        if (isFullscreen) {
          // SimpleBar should handle the scrolling
          return `overflow: hidden;`
        }
      }}
  }

  body.is-collapsing-sidenav {
    .c-Sidenav {
      pointer-events: none;
    }
  }

  ${printStyles}
`

export const fullscreenCss = css`
  position: fixed;
  right: 0;
  left: 0;
  top: ${({ theme }) => `${theme.navHeight}px`};
  bottom: 0;
`

export const modalCss = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent;
  z-index: 1040;
`

export const AppUI = styled.div`
  display: flex;
  background: #fff;
  flex-direction: row;
  position: relative;

  ${({ theme }) => (theme.isFullscreen ? fullscreenCss : '')}
  ${({ theme }) => (theme.isModal ? modalCss : '')}
`
